import React from 'react';
import { Popover, ListGroup, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Check, User } from 'lucide-react';

const TaskAssigneePopover = ({ members = [], assignedTo, onAssign, onClose, ...props }) => {
    // assignedTo is the userId of the assigned member

    const handleSelect = (memberId) => {
        onAssign(memberId);
        if (onClose) onClose();
        document.body.click(); // Close popover
    };

    return (
        <Popover id="task-assignee-popover" {...props} style={{ ...props.style, minWidth: '250px' }}>
            <Popover.Header as="h3">Assign To</Popover.Header>
            <Popover.Body className="p-0">
                <ListGroup variant="flush">
                    <ListGroup.Item
                        action
                        onClick={() => handleSelect(null)}
                        className="d-flex align-items-center gap-2"
                    >
                        <div className="rounded-circle bg-light d-flex align-items-center justify-content-center border" style={{ width: 24, height: 24 }}>
                            <User size={14} className="text-muted" />
                        </div>
                        <span className="flex-grow-1 text-muted">Unassigned</span>
                        {!assignedTo && <Check size={16} className="text-primary" />}
                    </ListGroup.Item>

                    {members.map(member => (
                        <ListGroup.Item
                            key={member.id} // Use member.id (Profile ID)
                            action
                            onClick={() => handleSelect(member.id)} // Use member.id
                            className="d-flex align-items-center gap-2"
                        >
                            {member.avatarUrl ? (
                                <img
                                    src={member.avatarUrl}
                                    alt={member.displayName}
                                    className="rounded-circle"
                                    style={{ width: 24, height: 24, objectFit: 'cover' }}
                                />
                            ) : (
                                <div
                                    className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold"
                                    style={{ width: 24, height: 24, fontSize: '10px', backgroundColor: member.color || '#6c757d' }}
                                >
                                    {member.displayName?.substring(0, 2).toUpperCase()}
                                </div>
                            )}
                            <span className="flex-grow-1 text-truncate">{member.displayName}</span>
                            {assignedTo === member.id && <Check size={16} className="text-primary" />}
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Popover.Body>
        </Popover>
    );
};

export default TaskAssigneePopover;
